import React from 'react';
import Location from './location';
import Department from './Department';
import OrganizationDetails from './OrganizationDetails';
import CardsBorder from '../../../components/Cards/CardsBorder';
import OrganizationSetup from './OrganizationSetup';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import {
  fetchCustomerById,
  updateCustomerProfile,
} from "../../../redux/customer/customerSlice";
const CustomerOrganizationSetup = () => {
      const location = useLocation();
      const dispatch = useDispatch();
      const navigate=useNavigate();
        const { currentCustomer} = useSelector((state) => state.customer);
       const orgSetup = currentCustomer?.orgStructureMode || "";
      const { userId } = useParams();
      
       
    const renderContent = () => {
        if (!orgSetup) {
            return (
            <div style={{ padding: "10px", display: "flex", flexDirection: "column", gap: "24px" }}>
                <OrganizationSetup userId={userId} />
                </div>)
        }

        if (orgSetup === "location-first") {
            return (
              <>
               <div className="flex justify-between gap-8 font-medium">
                          <div className="flex">
                            <p className="text-[#06513D] pt-2 px-10 text-xl">
                            Organization Structure
                            (Location To Department)
                            </p>
                          </div>
                          
                        </div>
              
             
                <div style={{ padding: "10px", display: "flex", flexDirection: "column", gap: "24px" }}>
                    <Location />
                    <Department />
                </div>
                </>
            );
        }

        if (orgSetup === "department-first") {
            return (
              <>
              <div className="flex justify-between gap-8 font-medium">
                          <div className="flex">
                            <p className="text-[#06513D] pt-2 px-10 text-xl">
                            Organization Structure
                            (Department To Location)
                            </p>
                          </div>
                          
                        </div>
                <div style={{ padding: "10px", display: "flex", flexDirection: "column", gap: "24px" }}>
                    <Department />
                    <Location />
                </div>
                </>
            );
        }

        // Fallback for any unexpected value
        return <OrganizationSetup />;
    };

    return (
        <div className="w-full overflow-hidden">
            <CardsBorder className="mt-6">
                {renderContent()}
            </CardsBorder>
        </div>
    );
}

export default CustomerOrganizationSetup;
